<template>
  <div>
    <MenuStorage/>
    <Reduce_debt/>
  </div>
</template>

<script>
import MenuStorage from "@/components/admin/stock/menustorage/MenuStorage";
import Reduce_debt from "@/components/admin/stock/storage_reducedebt/Reduce_debt";
export default {
name: "ReduceDebt",
  components: {
    Reduce_debt,
    MenuStorage
  }
}
</script>

<style scoped>

</style>